// @flow

import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import styles from './styles.scss';

import { setContactFormShowStatus } from '../../redux/actionsCreators';
import ContactData from './Data';
import Form from './Form';
import SuccessMessage from './SuccessMessage';

import type { PlaceType } from '../../api/types';
import type { DefaultStateType } from '../../redux/reducers';

type Props = {
  showContactForm: boolean,
  places: Array<PlaceType>,
  currentPlace: PlaceType,
  setContactFormShowStatus: (status: boolean) => void,
};

type State = {
  currentPlace: PlaceType,
  formWasSuccessfullySubmitted: boolean,
};

class ContactFormContainer extends React.Component<Props, State> {
  state = {
    currentPlace: this.props.currentPlace,
    formWasSuccessfullySubmitted: false,
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.currentPlace.id !== this.props.currentPlace.id) {
      this.setState({ currentPlace: this.props.currentPlace });
    }

    if (prevProps.showContactForm !== this.props.showContactForm && this.state.formWasSuccessfullySubmitted) {
      this.setState({ formWasSuccessfullySubmitted: false });
    }

    if (prevState.formWasSuccessfullySubmitted !== this.state.formWasSuccessfullySubmitted) {
      console.log('cdm');

      if (this.state.formWasSuccessfullySubmitted) {
        //$FlowFixMe
        document.body.classList.add('successMessage');
      } else {
        //$FlowFixMe
        document.body.classList.remove('successMessage');
      }
    }
  };

  close = () => {
    this.props.setContactFormShowStatus(false);

    if (document && document.body) {
      document.body.classList.remove('showContactForm');
    }
  };

  setCurrentPlace = currentPlace => this.setState({ currentPlace });

  onSubmit = () => this.setState({ formWasSuccessfullySubmitted: true });

  render() {
    return (
      <React.Fragment>
        <div className={styles['cover-close']} onClick={this.close} />
        <div className={classnames(styles.form, { [styles.hidden]: !this.props.showContactForm })}>
          <div className={styles['form-content']}>
            <div onClick={this.close} className={styles['form-close']}>
              <span>Close</span>
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAANCAYAAACdKY9CAAAAoklEQVQoU52SvQ0CMQyFvyehW4FFaCk4iQ3YgA1gCJrbgAFYCIn2GoobARqjRPYRIihCmih+P/GLI3yZWSfpGedyLzElwMz2wAHoJU0VeQecgK2kUU4+A0l8AzYhMrNEvgALYMxYVUzmWQSsC/Jcj5ZKpwTegaU7v8nSlAWeoxYF9NHmLHDRAByL0A9gJekatf9u+BL8d4bmV2qeQ/OkW//SCz8HaHBBwIwhAAAAAElFTkSuQmCC"
                alt="close"
              />
            </div>
            <div className={styles['form-inner']}>
              <div className={styles.links}>
                <a href="/forms-and-policies">Forms and Policies</a>
              </div>
              {this.state.formWasSuccessfullySubmitted ? (
                <SuccessMessage />
              ) : (
                <React.Fragment>
                  <ContactData
                    places={this.props.places}
                    currentPlace={this.state.currentPlace}
                    setCurrentPlace={this.setCurrentPlace}
                  />
                  <Form placeId={this.state.currentPlace.id} onSubmit={this.onSubmit} />
                </React.Fragment>
              )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: DefaultStateType): { showContactForm: boolean, currentPlace: PlaceType } => ({
  showContactForm: state.showContactForm,
  places: state.places,
  currentPlace: state.currentPlace,
});

const mapDispatchToProps = (dispatch): Object => ({
  setContactFormShowStatus(status) {
    dispatch(setContactFormShowStatus(status));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactFormContainer);



// WEBPACK FOOTER //
// ./src/components/Contact/index.js